import { render, staticRenderFns } from "./DispatchItem.vue?vue&type=template&id=38e25952&scoped=true&"
import script from "./DispatchItem.vue?vue&type=script&lang=js&"
export * from "./DispatchItem.vue?vue&type=script&lang=js&"
import style0 from "./DispatchItem.vue?vue&type=style&index=0&id=38e25952&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e25952",
  null
  
)

export default component.exports